export default __webpack_public_path__ + "static/media/arrow-black.1d6c9b53.svg";